import React from 'react'
import '../../Styles/ProductTrackHealth.scss'

// import DrHemanth from '../../Assests/Product/drHemantSharma.svg';
import DrHemanth from '../../Assests/Product/DrHemanthPNG.png';
import phonering from '../../Assests/Product/phonering.gif';
import typingMessage from '../../Assests/Product/typingMessage.gif';
import template from '../../Assests/Product/template.gif';
import heart from '../../Assests/Product/heart.gif';
import calender from '../../Assests/Product/calender.gif'

// import effortWelness from '../../Assests/Product/effeortwellness.svg';
 import effortWelness from '../../Assests/Product/effortWelnessPNG.png';
// import vizzhyMob from '../../Assests/Product/vizzhyMob.svg';
import vizzhyMob from '../../Assests/Product/vizzhyMobPNG.png';
import EmpoweringCaregiverSupport from './EmpoweringCaregiverSupport';

function ProdWhyGoPremium({ teamSectionRef }) {
    return (
        <>
            <div >

                <div className='custom-margin'>
                    <div className='track-youHealth pt-5 overall-text-color custom-margin-top' ref={teamSectionRef}>
                        <div>
                            Track your health effortlessly with <strong>12+ wellness features</strong><strong> from Food Logging to</strong>
                        </div>
                        <div className=''>
                            <strong>Activity Tracking</strong> and <strong>Medical Report Management.</strong>
                        </div>
                    </div>

                    <div className='track-youHealth  overall-text-color custom-margin-top'>
                        <div>
                            Receive <strong>personalized insights</strong> tailored to your entries and trends.<strong> New updates</strong>
                        </div>
                        <div className=''>
                            are added regularly offering features to suit your <strong>Evolving health needs.</strong>
                        </div>
                    </div>

                    <div className='track-youHealth mx-1 overall-text-color custom-margin-top'>
                        <div>
                            Plan your journey your way with <strong>Custom Schedules</strong> and seamless
                        </div>
                        <div >
                            <strong> Caregiver collaboration.</strong>
                        </div>
                    </div>
                </div>


                <div className='text-center responsive-imgHeight'>
                    <img className='responsive-DrHemanth' src={DrHemanth} alt="Dr. Hemanth Sharma" />
                </div>

                <div className='text-center why-go-height mob-view-gifs-text  fs-1 fw-bold overall-text-color'>
                    Why Go Premium with Vizzhy?
                </div>



                <div className='row text-center mt-5 pt-4 w-100 mob-view-gifs'>
                    <div className='col-md-3 d-flex justify-content-center flex-column align-items-center'>
                        <div className='gif-container'>
                            <img src={template} alt="template" className='gif-image' />
                        </div>
                        <div className='text-gif w-50 mt-3 ' >
                            Tailored health reports based on your entries and trends.
                        </div>
                    </div>

                    <div className='col-md-2 d-flex justify-content-center flex-column align-items-center'>
                        <div className='gif-container'>
                            <img src={typingMessage} alt="typingMessage" className='gif-image' />
                        </div>
                        <div className='text-gif w-75 mt-3 ' >
                            Voice-activated logging and manual options for convenience.
                        </div>
                    </div>
                    <div className='col-md-2 d-flex justify-content-center flex-column align-items-center'>
                        <div className='gif-container'>
                            <img src={heart} alt="heart" className='gif-image' />
                        </div>
                        <div className='text-gif w-75 mt-3'>
                            Keep all your important medical records in one place.
                        </div>
                    </div>
                    <div className='col-md-2 d-flex justify-content-center flex-column align-items-center'>
                        <div className='gif-container'>
                            <img src={calender} alt="calender" className='gif-image' />
                        </div>
                        <div className='text-gif w-75 mt-3'>
                            Track activities and progress with unmatched precision.
                        </div>
                    </div>
                    <div className='col-md-3 d-flex justify-content-center flex-column align-items-center'>
                        <div className='gif-container'>
                            <img src={phonering} alt="phonering" className='gif-image' />
                        </div>
                        <div className='text-gif w-50 mt-3'>
                            Get instant assistance whenever you need it.
                        </div>
                    </div>
                </div>






                {/* <div class="d-flex justify-content-center effortVizzhyheight">
                    <div class="image-efforts effortWidth">
                        <img src={effortWelness} alt="effortWelness" class="img-fluid  image-item" />
                    </div>
                    <div class="image-efforts effortWidth">
                        <img src={vizzhyMob} alt="vizzhyMob" class="img-fluid" />
                    </div>
                </div> */}

                <div className="row w-100 effortVizzhyheight d-flex justify-content-center align-items-center">
                    <div className="col-md-5 effortWelness-col d-flex justify-content-center">
                        <img src={effortWelness} alt="effortWelness" className=" effortWelness-img" />
                    </div>
                    <div className="col-md-5 effortWelness-col d-flex justify-content-center">
                        <img src={vizzhyMob} alt="vizzhyMob" className="effortWelness-img" />
                    </div>
                </div>




            </div>



            <EmpoweringCaregiverSupport />

        </>
    )
}

export default ProdWhyGoPremium